<template>
  <v-dialog v-model="open" max-width="640" persistent scrollable class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header d-flex align-center px-8 py-6">
        <div class="text-h5">
          <template v-if="isEdit">
            <span style="color: #2655F1;">编辑</span><span>eBlock</span>
          </template>
          <template v-else>
            <span style="color: #2655F1;">新增</span><span>eBlock</span>
          </template>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="emit('close')" />
      </div>
      <v-card-text class="pa-8 pt-0">
        <div class="form-grid-2">
          <div class="form-group">
            <label>eBlock 名称 <span class="required-star">*</span></label>
            <v-text-field v-model="draft.name" placeholder="请输入eBlock名称" variant="flat" density="compact"
              class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>型号</label>
            <v-autocomplete v-model="draft.modelTag" :items="filteredEblockModelOptions" item-title="title"
              item-value="value" placeholder="请输入关键字筛选并选择型号" variant="flat" density="compact" class="gm-input"
              hide-details auto-select-first no-data-text="无匹配型号" />
          </div>
          <div class="form-group">
            <label>UUID <span class="required-star">*</span></label>
            <v-text-field v-model="draft.uuid" placeholder="根据能量链序号自动生成UUID" variant="flat" density="compact"
              class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>设备 devID <span class="required-star">*</span></label>
            <v-text-field v-model="draft.deviceId" placeholder="请输入设备devID" variant="flat" density="compact"
              class="gm-input" hide-details />
          </div>
          <div v-if="showWaterMachineFields" class="form-group">
            <label>水机名称 <span class="required-star">*</span></label>
            <v-text-field v-model="draft.waterMachineName" placeholder="请输入水机名称" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
          <div v-if="showWaterMachineFields" class="form-group">
            <label>水机产品型号 <span class="required-star">*</span></label>
            <v-select v-model="draft.waterMachineModel" :items="conditionerModelOptions" item-title="title"
              item-value="value" :loading="conditionerModelLoading" placeholder="请选择水机产品型号" variant="flat"
              density="compact" class="gm-input" hide-details clearable
              @update:model-value="emit('water-machine-model-change', $event)" />
          </div>
          <div v-if="showWaterMachineFields" class="form-group">
            <label>水机 UUID <span class="required-star">*</span></label>
            <v-text-field v-model="draft.waterMachineUuid" placeholder="自动生成水机UUID" variant="flat"
              density="compact" class="gm-input" hide-details readonly />
          </div>
          <div v-if="showWaterMachineFields" class="form-group">
            <label>水机设备 devID <span class="required-star">*</span></label>
            <v-text-field v-model="draft.waterMachineDevId" placeholder="请输入水机设备devID" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="px-8 pb-8 pt-0 justify-end">
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4"
          @click="emit('close')">取消</v-btn>
        <v-btn color="#2655F1" variant="flat" class="gm-btn-primary px-10 text-white" @click="emit('submit')">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
const open = defineModel({ type: Boolean, default: false })
defineProps({
  draft: { type: Object, required: true },
  isEdit: { type: Boolean, default: false },
  filteredEblockModelOptions: { type: Array, default: () => [] },
  showWaterMachineFields: { type: Boolean, default: false },
  conditionerModelOptions: { type: Array, default: () => [] },
  conditionerModelLoading: { type: Boolean, default: false },
})
const emit = defineEmits(['close', 'submit', 'water-machine-model-change'])
</script>

<style scoped lang="scss" src="../styles/step-device.scss"></style>
